export default __webpack_public_path__ + "static/media/home-top1.c3c2e4c2.jpg";